import { z } from 'zod';

/**
 * Wire do `GET /rental/searches/recent`: o BFF valida a resposta
 * com este schema antes do `res.json`, e o web-chat a lê com ele na borda.
 * Irmão do `FlightRecentSearchSchema`.
 *
 * Uma busca recente é o critério que `POST /rental/search-page` recebeu, pronto
 * para ser reenviado: `ref` opaco de cada lugar e data-hora local-naive
 * (`2026-07-21T10:00`, com ou sem segundos). `label` é o nome que o BFF já
 * resolveu naquela busca — o ref sozinho não tem nome. `dropoff` ausente ⇔
 * devolução no lugar da retirada. "Minha localização" nunca entra: é o
 * endereço da pessoa naquela hora, não um atalho para amanhã.
 *
 * Mais recente primeiro, na ordem em que o back-end devolve. Pode vir vazio —
 * recente é conveniência, e o BFF degrada para `[]` em qualquer falha.
 */
const RentalRecentPlaceSchema = z.object({
  ref: z.string().min(1),
  label: z.string().min(1),
});

export const RentalRecentSearchSchema = z.object({
  pickup: RentalRecentPlaceSchema,
  dropoff: RentalRecentPlaceSchema.optional(),
  pickupAt: z.iso.datetime({ local: true }),
  dropoffAt: z.iso.datetime({ local: true }),
});
export type RentalRecentSearch = z.infer<typeof RentalRecentSearchSchema>;

export const RentalRecentSearchesResponseSchema = z.object({
  searches: z.array(RentalRecentSearchSchema),
});
